import * as React from "react"

const GridViewAsset = (props: React.SVGProps<any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={"#666"}
        viewBox="0 0 29 91"
        {...props}
    >
        <g clipPath="url(#clip0_4615_22586)">
            <path d="M5.913 90.251c.1.37.428.625.803.625H21.95a.836.836 0 0 0 .803-.625l2.151-7.966c.146-.54-.253-1.076-.803-1.076H4.565c-.55 0-.949.536-.803 1.076l2.15 7.966ZM28.678 52.923V13.137a.8.8 0 0 0-.03-.224L25.401 1.07a.842.842 0 0 0-.81-.622H4.076a.842.842 0 0 0-.81.622L.019 12.913a.8.8 0 0 0-.029.224v39.786c0 .465.378.846.84.846h27.008c.462 0 .84-.38.84-.846ZM13.71 78.393c0 .35.28.634.624.634a.629.629 0 0 0 .624-.634V56.586c0-.35-.28-.634-.624-.634a.629.629 0 0 0-.623.634v21.807ZM17.764 78.393c0 .35.28.634.624.634a.629.629 0 0 0 .624-.634V56.586c0-.35-.28-.634-.624-.634a.629.629 0 0 0-.624.634v21.807ZM22.13 78.393c0 .35.279.634.623.634a.629.629 0 0 0 .624-.634V56.586c0-.35-.28-.634-.624-.634a.629.629 0 0 0-.623.634v21.807ZM9.345 78.393c0 .35.279.634.623.634a.629.629 0 0 0 .624-.634V56.586c0-.35-.28-.634-.624-.634a.629.629 0 0 0-.623.634v21.807ZM4.98 78.393c0 .35.278.634.623.634a.629.629 0 0 0 .624-.634V56.586c0-.35-.28-.634-.624-.634a.629.629 0 0 0-.624.634v21.807Z" />
        </g>
    </svg>
)
export default GridViewAsset
